// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:42
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class DangerItem_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.DangerItem';
  $t: string = 'SagaSchema.DangerItem';

  public static GetMembers(): string[] {
    return [
      'DangerId',
      'QueryType',
      'ResultType',
      'DateStartUtc',
      'DateEndUtc',
      'PhoneNumber',
      'Name',
      'FirstName',
      'Address',
      'Registration',
      'Make',
      'Kind',
      'Color',
      'MakeId',
      'KindId',
      'ColorId',
      'Text',
      'HyperLink',
      'Description',
      'Owner',
      'OwnerName',
      'ParentId',
      'glblDangersLinkedId'
    ].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return DangerItem_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.DateStartUtc = this.DateStartUtc && new Date(this.DateStartUtc);
    this.DateEndUtc = this.DateEndUtc && new Date(this.DateEndUtc);

    ///*</AUTO_INIT_CODE>*/
  }

  components(): string[] {
    return ['SagaSchema.DangerItemPhoneNumber'];
  }

  private _components = {};

  component<T>(obj: any): Array<T> {
    let name: string;

    if (typeof obj === 'string') name = <string>obj;
    else if (obj.$t) name = obj.$t;
    else return [];

    if (!this._components[name]) {
      if (this.components().indexOf(name) >= 0) this._components[name] = [];
    }
    return this._components[name];
  }

  public add(obj: any): void {
    var compList = this.component<any>(obj.$t);

    // Only list elements can be added.
    for (var i = 0; i < compList.length; i++)
      if (compList[i].ObjId == obj.ObjId) {
        compList[i] = obj;
        return;
      }
    compList.push(obj);
    obj.ParentObjId = (<any>this).ObjId;
  }

  public remove(obj: any): void {
    if (obj == null) return;

    var compObj = <Array<any>>this.component<any>(obj.$t);
    if (compObj != null) {
      var index = compObj.indexOf(obj);
      if (index >= 0) compObj.splice(index, 1);
    }
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public DangerId: Guid = GuidTools.Empty;
  public QueryType: any;
  public ResultType: any;
  public DateStartUtc: Date = new Date();
  public DateEndUtc: Date = new Date();
  public PhoneNumber: string;
  public Name: string;
  public FirstName: string;
  public Address: string;
  public Registration: string;
  public Make: string;
  public Kind: string;
  public Color: string;
  public MakeId: number = 0;
  public KindId: number = 0;
  public ColorId: number = 0;
  public Text: string;
  public HyperLink: string;
  public Description: string;
  public Owner: number;
  public OwnerName: string;
  public ParentId: Guid = GuidTools.Empty;
  public glblDangersLinkedId: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.DangerId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
